import * as d3 from 'd3';
import Chart from '../chart';

export default class EventSummaryChart extends Chart {
  // First step of the D3 rendering.
  create() {
    this.svg = super.createRoot();
    this.main = this.svg
      .append('g')
      .attr('class', 'main')
      .attr('transform', `translate(${this.props.margin.left},${this.props.height / 2})`);

    this.frontInteraction = this.svg
      .append('rect')
      .attr('width', this.props.width)
      .attr('height', this.props.width)
      .attr('opacity', 0);

    this.background = this.main.append('g').attr('class', 'background');

    this.events = this.main.append('g').attr('class', 'events');

    this.legend = this.main.append('g').attr('class', 'legend').attr('opacity', 0);

    this.legend
      .append('text')
      .attr('x', 0)
      .attr('y', 13)
      .attr('text-anchor', 'start')
      .attr('font-size', 10)
      .text(this.props.strings.oneYearAgo);

    this.legend
      .append('text')
      .attr('x', this.props.width)
      .attr('y', 13)
      .attr('text-anchor', 'end')
      .attr('font-size', 10)
      .text(this.props.strings.today);

    this.barHeight = 8;
  }

  // Main D3 rendering, that should be redone when the data updates.
  update(state) {
    if ((state.events && state.events.length > 0) || state.showWithoutEvents) {
      this._drawChart(state);
    }
    this.drawLegend();
  }

  _drawChart(state) {
    const { start, end } = state;
    const eventData = state.events.map(e => e).sort((a, b) => +a.priority - +b.priority);
    const x = d3.scaleTime().range([0, this.props.width]).domain([start, end]);

    this.background
      .append('rect')
      .attr('x', 0)
      .attr('y', -this.barHeight / 2)
      .attr('width', this.props.width)
      .attr('height', this.barHeight)
      .attr('rx', this.barHeight / 2)
      .attr('ry', this.barHeight / 2)
      .style('fill', 'lightgrey');

    if (state.domain) {
      this.background
        .append('rect')
        .attr('x', x(state.domain[0]))
        .attr('y', -this.barHeight / 2)
        .attr('width', x(state.domain[1]) - x(state.domain[0]))
        .attr('height', this.barHeight)
        .attr('rx', this.barHeight / 2)
        .attr('ry', this.barHeight / 2)
        .style('fill', '#59bc7c');
    }

    const events = this.events.selectAll('.event').data(eventData);
    const pathsEnter = events.enter().append('circle').attr('class', 'event');
    pathsEnter
      .merge(events)
      .transition()
      .duration(750)
      .attr('fill', d => d.color)
      .attr('cy', 0)
      .attr('cx', d => x(d.date))
      .attr('r', this.barHeight / 2);

    this.legend.attr('opacity', 0);
  }

  drawLegend() {
    this.frontInteraction
      .on('mouseenter', () => {
        this.legend.attr('opacity', 1);
      })
      .on('mouseleave', () => {
        this.legend.attr('opacity', 0);
      });
  }
}
